import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import { cancelAnimation, Easing, runOnJS, useSharedValue, withTiming, } from 'react-native-reanimated';
import { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import { trustStoryUserDeckViewItems } from 'login/firstscreen/storyCarouselCards/userData';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useAppSelector } from 'store/hooks';
import { selectIsGBUser } from 'reducers/selectors';
import EachUserDeckView from './EachUserDeckView';
const UserDeckView = ({ largeVerticalPadding, embedded, darkBackground, }) => {
    const progressSharedValue = useSharedValue(0);
    const timeoutRef = React.useRef(undefined);
    const isGBUser = useAppSelector(selectIsGBUser);
    const items = React.useMemo(() => trustStoryUserDeckViewItems(isGBUser), [isGBUser]);
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const v3DeckAnimationStyles = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING, styles.flex);
    const startAnimation = React.useCallback(() => {
        const itemsLength = items.length - 1;
        const duration = itemsLength * 2200;
        progressSharedValue.value = withTiming(itemsLength, {
            duration,
            easing: Easing.linear,
        }, (finished) => {
            if (finished) {
                progressSharedValue.value = 0;
                runOnJS(startAnimation)();
            }
        });
    }, [progressSharedValue, items.length]);
    React.useEffect(() => {
        timeoutRef.current = setTimeout(() => {
            startAnimation();
        }, 600);
        return () => {
            clearTimeout(timeoutRef.current);
            cancelAnimation(progressSharedValue);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const deck = (<View style={styles.flex}>
      {items.map((item, index) => (<EachUserDeckView {...item} key={index} index={index} progressSharedValue={progressSharedValue} largeVerticalPadding={largeVerticalPadding} darkBackground={darkBackground}/>))}
    </View>);
    if (embedded) {
        return deck;
    }
    return (<View style={[styles.v3DeckAnimation, paddingHorizontalStyle]}>
      <View style={v3DeckAnimationStyles}>{deck}</View>
    </View>);
};
const styles = StyleSheet.create({
    v3DeckAnimation: {
        ...StyleSheet.absoluteFillObject,
        bottom: '5%',
    },
    flex: {
        flex: 1,
    },
});
export default React.memo(UserDeckView);
